import {LogLevel} from '../app/service/log-level';

export const environment = {
  production: false,
  logLevel: LogLevel.DEBUG,
  version: '1.0.0',
  tokenName: 'mlJwtTokenDev',
  coreApiBaseUrl: 'https://devcore.hellopractice.app/api/',
  callApiBaseUrl: 'https://devcall.hellopractice.app/api/',
  contactCenterApiBaseUrl: 'https://devcontactcenterapi.hellopractice.app/api/',
  workflowApiBaseUrl: 'https://devworkflow.hellopractice.app/api/',
  loginUrl: 'https://devid.hellopractice.app/login-contact-center',
  logoutUrl: 'https://devid.hellopractice.app/logout-contact-center'
};
